import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const DataListStyles = makeStyles((theme: Theme) =>
    createStyles({
        checkbox: {
            padding: theme.spacing(0.5),
            "& > .MuiSvgIcon-root": {
                fontSize: 14,
            },
        },
        pillContainer: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
        },
        pillCounter: {
            width: 20,
            height: 20,
            borderRadius: "40px",
            backgroundColor: theme.palette.info.main,
            color: theme.palette.common.white,
            fontSize: 8,
            fontWeight: 600,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: theme.spacing(0.5),
            flex: "0 0 auto",
        },
    })
);

export default DataListStyles;
